<template>
    <div class="flex flex-col justify-center items-center">
      <div class="mx-auto flex w-full mt-5 flex-col justify-center px-5 pt-0 md:h-[unset] max-w-[520px] lg:px-6 xl:pl-0">
        <div class="relative flex w-full flex-col pt-[20px] md:pt-0">
          <div class="rounded-lg border bg-card text-card-foreground shadow-sm mb-5 h-min max-w-full pt-8 pb-6 px-6 ">
            <p class="text-xl font-extrabold text-zinc-950 md:text-3xl">
              N'hésitez pas a me contacter !
            </p>
            <p class="mb-6 mt-1 text-sm font-medium text-zinc-500 md:mt-4 md:text-base">
              Je serai ravi d'échanger avec vous.
            </p>
            <img class="w-24 m-auto" src="/img/mail.png"/>
            <div class="flex flex-row justify-center mt-6 space-x-4">
              <a href="mailto:stawskimaxime@live.fr" target="_blank">
                <button class="bg-[#4C56D7] hover:bg-sky-800 px-10 py-2 text-white sm:px-14 rounded-xl px-5">Envoyer un mail</button>
              </a>
              <a href="https://www.linkedin.com/in/maxime-stawski" target="_blank">
                <button class="bg-[#4C56D7] hover:bg-sky-800 px-10 py-2 text-white sm:px-14 rounded-xl px-5">LinkedIn</button>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>

</template>
<script>
export default {
  name: 'ComponentContact',
}
</script>